import React from "react";
import { ChevronRight } from "lucide-react";

export default function BookingCard({ booking, onSelect, isManager, onAssign }) {
  const report = booking.ops_report;
  const statusLabel = report?.ops_completed_at ? "Completed"
    : report?.ops_setup_started_at ? "In Progress"
    : report?.ops_arrived_at ? "On Site" : "Pending";
  const statusColor = report?.ops_completed_at ? "bg-green-100 text-green-700"
    : report?.ops_setup_started_at ? "bg-yellow-100 text-yellow-700"
    : report?.ops_arrived_at ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-500";

  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm mb-2 active:scale-[0.98] transition-transform cursor-pointer" onClick={onSelect} data-testid={`ops-booking-card-${booking.id}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-bold text-sm text-[#1E1B4B]">{booking.customer_name}</span>
            <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${statusColor}`}>{statusLabel}</span>
          </div>
          <p className="text-xs text-[#94a3b8] mt-0.5">{booking.date} | {booking.package} | {booking.occasion}</p>
          <p className="text-xs text-[#475569] mt-0.5 truncate">{booking.address}</p>
          {booking.assigned_ops_name && <p className="text-[10px] text-[#E83E8C] font-medium mt-0.5">Assigned: {booking.assigned_ops_name}</p>}
        </div>
        <div className="flex items-center gap-1">
          {isManager && !booking.assigned_ops_name && onAssign && (
            <button onClick={(e) => { e.stopPropagation(); onAssign(booking); }} className="px-2 py-1 bg-[#E83E8C] text-white rounded-lg text-[10px] font-medium mr-1">Assign</button>
          )}
          <ChevronRight size={16} className="text-[#94a3b8] flex-shrink-0" />
        </div>
      </div>
    </div>
  );
}
